import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://awnvrpeqgojsamnbydix.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF3bnZycGVxZ29qc2FtbmJ5ZGl4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzAxNjAxMDAsImV4cCI6MjA0NTczNjEwMH0.n-whT89JRYSIJxiAYMFo_Oqeud9cm7dAt4xio4wnuZE';
export const supabase = createClient(supabaseUrl, supabaseKey);